import {
  issueStatuses,
  issueTypes,
} from "pages/CertificateValidation/DetailView/usePersistVerification/issueStateConfigs";

interface IssueMinimal {
  issueTypeId?: string | null;
  issueStatusId?: string | null;
}

const openTaskIssueStatusIds = new Set([
  issueStatuses.Open,
  issueStatuses.Reopened,
  issueStatuses["Pending Review"],
  issueStatuses.New,
  issueStatuses["In Progress"],
  issueStatuses.NewTG8,
  issueStatuses.OpenTG8,
  issueStatuses.Reassignment,
  issueStatuses.Rejected,
]);

export const hasActiveErrorCorrection = (issues: IssueMinimal[] | null | undefined): boolean =>
  !!issues?.some(
    (issue) => issue?.issueTypeId === issueTypes["Error Correction"] && issue?.issueStatusId !== issueStatuses.Closed
  );

export const hasOpenErrorCorrectionTask = (issues: IssueMinimal[] | null | undefined): boolean =>
  !!issues?.some(
    (issue) =>
      issue?.issueTypeId === issueTypes["Error Correction"] &&
      !!issue.issueStatusId &&
      openTaskIssueStatusIds.has(issue.issueStatusId)
  );
